import Link from 'next/link';
import { Icon } from '@/components/ui/icon';

const MenuItemBlockLinks = ({ label, variant, navigationBlockLinksContent: content }) => {
  return (
    <div>
      <div className="txt-sm text-grey-600 mb-5 flex flex-col gap-5 font-semibold uppercase">{label}</div>
      <div className={`flex flex-col ${variant === 'graphic' ? 'gap-6' : 'gap-2.5'}`}>
        {(content || []).map((link) =>
          variant === 'graphic' ? (
            <MenuItemLinkGraphic key={link.id} {...link} />
          ) : (
            <MenuItemLinkSimple key={link.id} {...link} />
          )
        )}
      </div>
    </div>
  );
};
export default MenuItemBlockLinks;

const COLORS = {
  brand: 'bg-brand-500 border-brand-500 text-white',
  brand_outline: 'bg-transparent border-brand-500 text-brand-500',
  blue: 'bg-blue-500 border-blue-500 text-white',
  green: 'bg-green-500 border-green-500 text-white',
  purple: 'bg-purple-500 border-purple-500 text-white',
  yellow: 'bg-yellow-500 border-yellow-500 text-white',
  red: 'bg-red-500 border-red-500 text-white'
};

const MenuItemLinkGraphic = ({ title, description, link, icon, color }) => {
  const iconColorClass = COLORS[color] || COLORS.brand;

  return link ? (
    <Link
      href={link}
      target={link.startsWith('http') ? '_blank' : '_self'}
      rel={link.startsWith('http') ? 'noopener noreferrer' : undefined}
    >
      <div className="group/item flex gap-4">
        <div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border ${iconColorClass}`}>
          <Icon type={icon} />
        </div>
        <div className="flex min-h-8 flex-col justify-center">
          <div className="group-hover/item:text-brand-400 txt-lg font-medium">{title}</div>
          {description && <div className="txt-md text-grey-700 mt-1">{description}</div>}
        </div>
      </div>
    </Link>
  ) : (
    <div className="flex gap-4">
      <div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border ${iconColorClass}`}>
        <Icon type={icon} />
      </div>
      <div className="flex min-h-8 flex-col justify-center">
        <div className="txt-lg font-medium">{title}</div>
        {description && <div className="txt-md text-grey-700 mt-1">{description}</div>}
      </div>
    </div>
  );
};

const MenuItemLinkSimple = ({ title, link, icon }) => {
  return link ? (
    <Link
      href={link}
      target={link.startsWith('http') ? '_blank' : '_self'}
      rel={link.startsWith('http') ? 'noopener noreferrer' : undefined}
      className="txt-md hover:text-brand-400 flex min-h-8 items-center gap-3 font-medium tracking-wider"
    >
      <Icon type={icon} /> <span>{title}</span>
    </Link>
  ) : (
    <div className="txt-md text-grey-400 flex min-h-8 items-center gap-3 font-medium tracking-wider">
      <Icon type={icon} /> <span>{title}</span>
    </div>
  );
};
